<template>
  <Field class="form-field" as="fieldset" :width="width">
    <header v-if="label" class="flex w-full justify-between mb-2">
      <legend class="text-base font-medium text-gray-900">{{ label }}</legend>
      <Button
        text="Hinzufügen"
        icon="add"
        type="button"
        @click="add"
      />
    </header>
    <div class="space-y-2">
      <div
        v-if="values.length"
        v-for="(value, key) in values"
        class="border relative rounded bg-gray-50"
        :key="key"
      >
        <div class="flex justify-end border-b">
          <button
            class="p-3"
            title="Entfernen"
            type="button"
            @click="remove(key)"
          >
            <Icon type="remove" size="5" />
          </button>
        </div>
        <div class="grid gap-6 xl:grid-cols-12 p-4">
          <Fields
            :errors="error?.[key]"
            :fields="fields"
            v-model="values[key]"
          />
        </div>
      </div>
      <div v-else class="border rounded px-4 py-3 text-sm text-center text-gray-500 bg-gray-50">
        {{ empty }}
      </div>
    </div>
  </Field>
</template>

<script>
import Field from 'Web/Form/Fields/Field.vue';
import Button from 'Web/Shared/Button.vue';
import Icon from 'Web/Shared/Icon.vue';
import rescue from '@/helpers/rescue';
import mapValues from 'lodash/mapValues';
import { defineAsyncComponent, ref, watch, watchEffect } from 'vue';

const Fields = defineAsyncComponent(() => import('../Fields.vue'));

export default {
  inheritAttrs: false,
  emits: [
    'update:modelValue',
  ],
  components: {
    Button,
    Fields,
    Field,
    Icon,
  },
  props: {
    empty: {
      type: String,
      default: 'Keine Einträge',
    },
    error: [Array, Object],
    fields: {
      type: Object,
      required: true,
    },
    label: String,
    modelValue: null,
    name: String,
    width: String,
  },
  setup(props, { emit }) {
    const values = ref([]);

    watchEffect(() => {
      const value = rescue(() =>
        JSON.parse(props.modelValue), props.modelValue);

      values.value = value ?? [];
    });

    watch(() => values.value, value => {
      emit('update:modelValue', value);
    }, { deep: true });

    function add() {
      values.value.push(mapValues(props.fields, () => null));
    }

    function remove(key) {
      values.value.splice(key, 1);
    }

    return {
      add,
      remove,
      values,
    }
  }
}
</script>
